import { UserEmailPrefsDto } from "../../types/dto";
import { isMockMode, post, simulateDelay } from "../api";

export interface UpdateEmailPrefsRequest {
	code: string;
	email: string;
	prefs: UserEmailPrefsDto;
}

export const updateEmailPrefs = (data: UpdateEmailPrefsRequest) => {
	if (isMockMode()) {
		const testData = { success: true };

		return simulateDelay(50, () => testData);
	}

	return post("EmailPrefs/Update", data, {
		successMessage: "Email preferences successfully updated",
	});
};
